function getAudioDurationSeconds(
  audio: Pick<HTMLAudioElement, "duration">,
): number | undefined {
  return Number.isFinite(audio.duration) && audio.duration > 0
    ? audio.duration
    : undefined;
}

export { getAudioDurationSeconds };
